module.exports = __webpack_public_path__ + "static/media/expertise-approve.459317be.svg";